import React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import MDBox from "components/MDBox";
import DataTableHeadCell from "examples/Tables/DataTable/DataTableHeadCell";
import DataTableBodyCell from "examples/Tables/DataTable/DataTableBodyCell";
import { styled } from "@mui/system";

const TableContainerWrapper = styled(TableContainer)(({ theme }) => ({
  maxHeight: "300px", // Adjust the height as needed
  overflowY: "auto",
}));

function DataTable({ data, columns, title }) {
  return (
    <TableContainerWrapper>
      <Table>
        <MDBox component="thead">
          <TableRow>
            {columns.map((column, index) => (
              <DataTableHeadCell key={index} width="auto" align={column.align}>
                {column.headerName}
              </DataTableHeadCell>
            ))}
          </TableRow>
        </MDBox>
        <TableBody>
          {data.results.map((row) => (
            <TableRow key={row.id}>
              {columns.map((column, index) => (
                <DataTableBodyCell key={index} align={column.align}>
                  {row[column.field]}
                </DataTableBodyCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainerWrapper>
  );
}

DataTable.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string,
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      headerName: PropTypes.string.isRequired,
      align: PropTypes.string,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
};

export default DataTable;
